if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        // AURYN MOBILE LIGHTBOX FIX: no scrollIntoView or 1100px-image centring
        // on phones; CSS fits the active image to the viewport instead.
        const container = this.querySelector('[role="document"]');
        if (window.matchMedia('(max-width: 749px)').matches) {
          if (container) {
            container.scrollLeft = 0;
            container.scrollTop = 0;
          }
        } else {
          activeMedia.scrollIntoView();
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
